import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saDataAccessibilityChartConfig } from '../chartConfigs';

interface DataAccessibilitySaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataAccessibilitySaEcharts: React.FC<DataAccessibilitySaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saDataAccessibilityChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default DataAccessibilitySaEcharts;
